// extracted by mini-css-extract-plugin
export default {"headerclass":"table_headerclass__2xiZi","headerText":"table_headerText__D3+Xs","rowText":"table_rowText__PhYc7"};